import React from 'react';
import Draggable from 'react-draggable';
import { updateShapePosition, updateShapeSize, updateShapeRotation, updateBubbleControlPoint, selectShape, updateCurrentSlideThumbnail, changeInteractionState, moveShape } from '../../../actions/CurrentSlideActions';
import { detectCurrentAngle, transformPointToRotatedSystem, transformPointFromRotatedSystem, uiProperties, getTouchPosition, isTextBox, isTextBubble, useScaleFactor } from '../../utils/TransformToolUtils';
import textSizeUtils from '../../utils/TextSizeUtils';
import shapeAspectRatioUtils from '../../utils/ShapeAspectRatioUtils';
import appParameters from '../../utils/AppParameters';
import modeType from '../../../constants/ModeConstants';
import shapeTypes from '../../../constants/ShapeConstants';
import platformDetection from '../../utils/PlatformDetection';
import previewCommands from '../../utils/PreviewCommands';
import selectionManager from '../../utils/SelectionManager';
import touchUtils from '../../utils/TouchUtils';
import multiTouchUtils from '../../utils/MultiTouchUtils';
import animationManager from '../../utils/AnimationManager';
import mindMapUtils from '../../utils/MindMapUtils';
import saveManager from '../../utils/SaveManager';
import audioEditorUtils from '../../audioEditor/utils/AudioEditorUtils';
import { changeContextMode, refreshShapePosition } from '../../../actions/MenuActions';
import textEditorUtils from '../../menus/textEditorTool/utils/TextEditorUtils';

export const InteractiveShape = React.createClass({
    propTypes: {
        dispatch: React.PropTypes.func.isRequired,
        children: React.PropTypes.object.isRequired,
        shapeModel: React.PropTypes.object.isRequired,
        rotatable: React.PropTypes.bool,
        isBubble: React.PropTypes.bool
    },
    getInitialState() {
        const {rotation} = this.props.shapeModel;
        let rot = 0;

        if (!isNaN(rotation))
            rot = rotation;

        return {
            interaction: 'none',
            rotation: rot,
            scaleOffsetX: 1,
            scaleOffsetY: 1,
            translateOffsetX: 0,
            translateOffsetY: 0,
            trX:0,
            trY:0,
            cx:0,
            cy:0,
            cx1:0,
            cy1:0,
            cx2:0,
            cy2:0,
            cx3:0,
            cy3:0,
            cx4:0,
            cy4:0,
            cx5:0,
            cy5:0,
            startX: 0,
            startY: 0,
            startWidth:0,
            startHeight:0,
            horizontalFlip:1,
            verticalFlip:1,
            isMultiTouch: false
        };
    },
    componentDidMount() {
        if (platformDetection.isFirefox() == false)
            document.addEventListener('mouseout', this.onFocusOut);
    },
    componentWillUnmount() {
        if (platformDetection.isFirefox() == false)
            document.removeEventListener('mouseout', this.onFocusOut);
    },
    onFocusOut(evt) {
        var position = getTouchPosition(evt);

        if (position.x < 2 || position.y < 2 || position.x > (window.innerWidth - 2) || position.y > (window.innerHeight -2)) {
           if (this.isScaleInteraction() == true)
                this.onScaleShapeStopped();
           else if (this.state.interaction == 'move')
                this.onMoveShapeStopped();
        }
    },
    updateScaleState(coreEvent) {
        const width = this.state.startWidth;
        const height = this.state.startHeight;

        const {rotation} = this.props.shapeModel;
        let newWidth;
        let newHeight;
        let tx;
        let ty;
        let id = this.getCorrectId(coreEvent.id);
        let newDelta = transformPointToRotatedSystem({x: coreEvent.lastX / this.scaleFactor(), y: coreEvent.lastY / this.scaleFactor()}, rotation);
        const aspectRatio = height / width;
        var useAspectRatio = false;

        if (shapeAspectRatioUtils.isShift == true || (shapeAspectRatioUtils.default && shapeAspectRatioUtils.default.isShift == true))
            useAspectRatio = true;

        let trX = newDelta.x;
        let trY = newDelta.y;

        switch (id) {
            case 'topLeft': {
                newWidth = width - newDelta.x;
                tx = newDelta.x;

                if (useAspectRatio == false) {
                    newHeight = height - newDelta.y;
                    ty = newDelta.y;
                } else {
                    newHeight = newWidth * aspectRatio;
                    ty = tx * aspectRatio;
                    trY = ty;
                }
                break;
            }
            case 'topRight': {
                newWidth = width + newDelta.x;
                tx = 0;

                if (useAspectRatio == false) {
                    newHeight = height - newDelta.y;
                    ty = newDelta.y;
                } else {
                    newHeight = newWidth * aspectRatio

                    tx =  0;
                    ty = - newDelta.x * aspectRatio;

                    trX = newDelta.x;
                    trY = - newDelta.x * aspectRatio;
                }
                break;
            }
            case 'bottomRight': {
                newWidth = width + newDelta.x;
                tx = 0;

                if (useAspectRatio == false) {
                    newHeight = height + newDelta.y;
                    ty = 0;
                } else {
                    newHeight = newWidth * aspectRatio;
                    ty = tx * aspectRatio;
                    trY = newDelta.x * aspectRatio;
                }
                break;
            }
            case 'bottomLeft': {
                newWidth = width - newDelta.x;
                tx = newDelta.x;

                if (useAspectRatio == false) {
                    newHeight = height + newDelta.y;
                    ty = 0;
                } else {
                    newHeight = newWidth * aspectRatio;

                    tx = newDelta.x;
                    ty = 0;

                    trX = newDelta.x;
                    trY = - newDelta.x * aspectRatio;
                }
                break;
            }
            case 'middleLeft': {
                newWidth = width - newDelta.x;
                newHeight = height;
                tx = newDelta.x;

                ty = 0;
                trY = 0;
                break;
            }
            case 'middleRight': {
                newWidth = width + newDelta.x;
                newHeight = height;
                tx = 0;

                ty = 0;
                trY = 0;
                break;
            }
            case 'middleTop': {
                newWidth = width;
                newHeight = height - newDelta.y;
                ty = newDelta.y;

                tx = 0;
                trX = 0;
                break;
            }
            case 'middleBottom': {
                newWidth = width;
                newHeight = height + newDelta.y;
                ty = 0;

                tx = 0;
                trX = 0;
                break;
            }
        }

        return {newWidth, newHeight, tx, ty, id, trX, trY};
    },
    getCorrectId(id) {
        var index = id.indexOf('_');

        if (index != -1)
            return id.substring(0, index);
        else
            return id;
    },
    onScaleStart(e, coreEvent) {
        e.preventDefault();
        const {shapeModel} = this.props;

        if (shapeModel.isLocked == true)
            return;

        this.setState({
            startX: shapeModel.x,
            startY: shapeModel.y,
            startWidth: shapeModel.width,
            startHeight: shapeModel.height,
            horizontalFlip: shapeModel.horizontalFlip,
            verticalFlip: shapeModel.verticalFlip,
            coreEventObject: undefined,
            interaction: this.getCorrectId(coreEvent.node.id)
        });

        if (isTextBubble(shapeModel) == true) {
            var controlPointState = {};

            controlPointState.cx = shapeModel.cx;
            controlPointState.cy = shapeModel.cy;

            if (shapeModel.cx1 && shapeModel.cy1) {
                controlPointState.cx1 = shapeModel.cx1;
                controlPointState.cy1 = shapeModel.cy1;
            }

            if (shapeModel.cx2 && shapeModel.cy2) {
                controlPointState.cx2 = shapeModel.cx2;
                controlPointState.cy2 = shapeModel.cy2;
            }

            if (shapeModel.cx3 && shapeModel.cy3) {
                controlPointState.cx3 = shapeModel.cx3;
                controlPointState.cy3 = shapeModel.cy3;
            }

            if (shapeModel.cx4 && shapeModel.cy4) {
                controlPointState.cx4 = shapeModel.cx4;
                controlPointState.cy4 = shapeModel.cy4;
            }

            if (shapeModel.cx5 && shapeModel.cy5) {
                controlPointState.cx5 = shapeModel.cx5;
                controlPointState.cy5 = shapeModel.cy5;
            }

            this.setState(controlPointState);
        }

        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, true));
    },
    onScaleDrag(e, coreEvent) {
        if (this.isScaleInteraction() == false)
            return;

        if (this.props.shapeModel.isLocked == true)
            return;

        const {width, height, type} = this.props.shapeModel;
        const coreEventObject = {lastX:coreEvent.lastX, lastY: coreEvent.lastY, id:coreEvent.node.id};

        if (useScaleFactor(type)) {
            const newPosition = this.updateScaleState(coreEventObject);

            this.setState({
                scaleOffsetX: newPosition.newWidth / width,
                scaleOffsetY: newPosition.newHeight / height,
                translateOffsetX: newPosition.tx,
                translateOffsetY: newPosition.ty,
                trX:newPosition.trX,
                trY:newPosition.trY,
                interaction: this.getCorrectId(newPosition.id),
                coreEventObject: coreEventObject
            });
        } else {
            this.setState({
                interaction: this.getCorrectId(coreEvent.node.id)
            });

            this.scaleContent(coreEventObject);
        }
    },
    scaleContent(coreEvent, endResize = false) {
        const {shapeModel, dispatch} = this.props;
        const newPosition = this.updateScaleState(coreEvent);

        const rotatedTranslation = transformPointFromRotatedSystem({x: newPosition.trX, y: newPosition.trY}, shapeModel.rotation);

        const oldCenterX = this.state.startX + this.state.startWidth / 2;
        const oldCenterY = this.state.startY + this.state.startHeight / 2;

        const newCenterX = oldCenterX + rotatedTranslation.x / 2;
        const newCenterY = oldCenterY + rotatedTranslation.y / 2;

        let newX = newCenterX - newPosition.newWidth / 2;
        let newY = newCenterY - newPosition.newHeight / 2;

        // flip functionality
        var hf = (!this.state.horizontalFlip) ? 1 : this.state.horizontalFlip;
        var vf = (!this.state.verticalFlip) ? 1 : this.state.verticalFlip;
        let horizontalFlip = newPosition.newWidth < 0 ? (-1 * hf) : hf;
        let verticalFlip = newPosition.newHeight < 0 ? (-1 * vf) : vf;

        if (isTextBox(this.props.shapeModel)) {
            horizontalFlip = 1;
            verticalFlip = 1;
        }

        if (newPosition.newWidth < 0)
            newX = newX + newPosition.newWidth;

        if (newPosition.newHeight < 0)
            newY = newY + newPosition.newHeight;

        var cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5;

        if (isTextBubble(shapeModel)) {
            var newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx, this.state.cy);
            cx = newControlPoint.x;
            cy = newControlPoint.y;

            if (shapeModel.cx1 && shapeModel.cy1) {
                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx1, this.state.cy1);
                cx1 = newControlPoint.x;
                cy1 = newControlPoint.y;
            }

            if (shapeModel.cx2 && shapeModel.cy2) {
                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx2, this.state.cy2);
                cx2 = newControlPoint.x;
                cy2 = newControlPoint.y;
            }

            if (shapeModel.cx3 && shapeModel.cy3) {
                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx3, this.state.cy3);
                cx3 = newControlPoint.x;
                cy3 = newControlPoint.y;
            }

            if (shapeModel.cx4 && shapeModel.cy4) {
                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx4, this.state.cy4);
                cx4 = newControlPoint.x;
                cy4 = newControlPoint.y;
            }

            if (shapeModel.cx5 && shapeModel.cy5) {
                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx5, this.state.cy5);
                cx5 = newControlPoint.x;
                cy5 = newControlPoint.y;
            }
        }

        if (platformDetection.isIOS() == false) {
            if (isTextBox(shapeModel)) {

                if (Math.abs(newPosition.newWidth) < 25 || Math.abs(newPosition.newHeight) < 25)
                    return;

                textSizeUtils.updateFontSize(shapeModel, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), dispatch, endResize);
            }
        }

        dispatch(updateShapeSize(
            shapeModel.uuid,
            Math.abs(newPosition.newWidth),
            Math.abs(newPosition.newHeight),
            newX,
            newY,
            horizontalFlip,
            verticalFlip,
            cx,
            cy,
            cx1,
            cy1,
            cx2,
            cy2,
            cx3,
            cy3,
            cx4,
            cy4,
            cx5,
            cy5
        ));

        mindMapUtils.updateShapePositionWhenResize(shapeModel);

        if (platformDetection.isIOS() == true && endResize == true)
            setTimeout(this.refreshShape.bind(this), 5);

        saveManager.isContentChanged(true);
    },
    refreshShapeAfterResize() {
        setTimeout(this.refreshShape.bind(this), 2);
    },
    refreshShape() {
        const {shapeModel, dispatch} = this.props;

        if (shapeModel.type == shapeTypes.CHARACTER || shapeModel.type == shapeTypes.IMAGE) {
            dispatch(moveShape(shapeModel.uuid, 1, 1));
            dispatch(moveShape(shapeModel.uuid, -1, -1));
        }
    },
    keepAspectRatioForControlPoint(x, y, width, height, cx, cy) {
        var newX;
        var newY;

        if (cx < this.state.startX)
            newX = x + (cx - this.state.startX);
        else if (cx > (this.state.startX + this.state.startWidth))
            newX = x + width + (cx - (this.state.startX + this.state.startWidth));
        else
            newX = x + (cx - this.state.startX);

        if (cy < this.state.startY)
            newY = y + (cy - this.state.startY);
        else if (cy > (this.state.startY + this.state.startHeight))
            newY = y + height + (cy - (this.state.startY + this.state.startHeight));
        else
            newY = y + (cy - this.state.startY);

        return {x: newX, y: newY};
    },
    isScaleInteraction() {
        switch (this.state.interaction) {
            case 'topLeft':
            case 'topRight':
            case 'bottomLeft':
            case 'bottomRight':
            case 'middleTop':
            case 'middleLeft':
            case 'middleBottom':
            case 'middleRight': {
                return true;
            }
            default: {
                return false;
            }
        }
    },
    onScaleShapeStopped(e) {
        if (this.isScaleInteraction() == false)
            return;

        if (e)
            e.preventDefault();

        if (this.props.shapeModel.isLocked == true)
            return;

        if (useScaleFactor(this.props.shapeModel.type) && this.state.coreEventObject) {
            this.scaleContent(this.state.coreEventObject, true);
        } else {
            if (platformDetection.isIOS() == true) {
                if (isTextBox(this.props.shapeModel))
                    textSizeUtils.updateFontSize(this.props.shapeModel, Math.abs(this.props.shapeModel.width), Math.abs(this.props.shapeModel.height), this.props.dispatch, true, this.state.startWidth, this.state.startHeight);
            }
        }

        this.setState({
            scaleOffsetX: 1,
            scaleOffsetY: 1,
            translateOffsetX: 0,
            translateOffsetY: 0,
            trX:0,
            trY:0,
            interaction: 'none'
        });

        audioEditorUtils.addActionToHistory();
        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, false));

        this.updateThumbnail();

        this.props.dispatch(refreshShapePosition(this.props.shapeModel.uuid));
    },
    updateThumbnail () {
        //return; // updating thumbnail causes a downtime so it affects the performance
        const {dispatch} = this.props;
        dispatch(updateCurrentSlideThumbnail(true));
    },
    onControlPointStart(e, coreEvent) {
        e.preventDefault();
        const {shapeModel} = this.props;

        if (shapeModel.isLocked == true)
            return;

        var stateObject = {};
        var id = this.getCorrectId(coreEvent.node.id);

        switch(id) {
            case 'controlPoint': {
                stateObject.cx = shapeModel.cx;
                stateObject.cy = shapeModel.cy;
                stateObject.interaction = id;
                break;
            }

            case 'controlPoint1': {
                stateObject.cx1 = shapeModel.cx1;
                stateObject.cy1 = shapeModel.cy1;
                stateObject.interaction = id;
                break;
            }

            case 'controlPoint2': {
                stateObject.cx2 = shapeModel.cx2;
                stateObject.cy2 = shapeModel.cy2;
                stateObject.interaction = id;
                break;
            }

            case 'controlPoint3': {
                stateObject.cx3 = shapeModel.cx3;
                stateObject.cy3 = shapeModel.cy3;
                stateObject.interaction = id;
                break;
            }

            case 'controlPoint4': {
                stateObject.cx4 = shapeModel.cx4;
                stateObject.cy4 = shapeModel.cy4;
                stateObject.interaction = id;
                break;
            }

            case 'controlPoint5': {
                stateObject.cx5 = shapeModel.cx5;
                stateObject.cy5 = shapeModel.cy5;
                stateObject.interaction = id;
                break;
            }
        }

        this.setState(stateObject);
        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, true));
    },
    onControlPointDrag(e, coreEvent) {
        e.preventDefault();
        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true)
            return;

        var stateCx, stateCy;
        var id = this.getCorrectId(coreEvent.node.id);

        switch(id) {
            case 'controlPoint': {
                stateCx = this.state.cx;
                stateCy = this.state.cy;
                break;
            }

            case 'controlPoint1': {
                stateCx = this.state.cx1;
                stateCy = this.state.cy1;
                break;
            }

            case 'controlPoint2': {
                stateCx = this.state.cx2;
                stateCy = this.state.cy2;
                break;
            }

            case 'controlPoint3': {
                stateCx = this.state.cx3;
                stateCy = this.state.cy3;
                break;
            }

            case 'controlPoint4': {
                stateCx = this.state.cx4;
                stateCy = this.state.cy4;
                break;
            }

            case 'controlPoint5': {
                stateCx = this.state.cx5;
                stateCy = this.state.cy5;
                break;
            }
        }

        dispatch(updateBubbleControlPoint(shapeModel.uuid, stateCx + coreEvent.lastX / this.scaleFactor(), stateCy + coreEvent.lastY / this.scaleFactor(), id));

        saveManager.isContentChanged(true);
    },
    onControlPointStop(e, coreEvent) {
        e.preventDefault();

        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true)
            return;

        var stateCx, stateCy;
        var id = this.getCorrectId(coreEvent.node.id);

        switch(id) {
            case 'controlPoint': {
                stateCx = this.state.cx;
                stateCy = this.state.cy;
                break;
            }

            case 'controlPoint1': {
                stateCx = this.state.cx1;
                stateCy = this.state.cy1;
                break;
            }

            case 'controlPoint2': {
                stateCx = this.state.cx2;
                stateCy = this.state.cy2;
                break;
            }

            case 'controlPoint3': {
                stateCx = this.state.cx3;
                stateCy = this.state.cy3;
                break;
            }

            case 'controlPoint4': {
                stateCx = this.state.cx4;
                stateCy = this.state.cy4;
                break;
            }

            case 'controlPoint5': {
                stateCx = this.state.cx5;
                stateCy = this.state.cy5;
                break;
            }
        }

        dispatch(updateBubbleControlPoint(shapeModel.uuid, stateCx + coreEvent.lastX / this.scaleFactor(), stateCy + coreEvent.lastY / this.scaleFactor(), id));

        this.setState({
            interaction: 'none',
            cx: 0,
            cy: 0,
            cx1: 0,
            cy1: 0,
            cx2: 0,
            cy2: 0,
            cx3: 0,
            cy3: 0,
            cx4: 0,
            cy4: 0,
            cx5: 0,
            cy5: 0,
            scaleOffsetX: 1,
            scaleOffsetY: 1,
            translateOffsetX: 0,
            translateOffsetY: 0,
            trX:0,
            trY:0
        });

        audioEditorUtils.addActionToHistory();
        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, false));

        this.updateThumbnail();
        saveManager.isContentChanged(true);

        this.props.dispatch(refreshShapePosition(this.props.shapeModel.uuid));

        if (this.props.shapeModel.isMindMap && Math.abs(coreEvent.lastX) <= 2 && Math.abs(coreEvent.lastY) <= 2) // it's click (not drag-drop) on a mindMap node
            this.openMindMapMenu(id);
    },
    openMindMapMenu(id) {
        setTimeout(function() {
            mindMapUtils.selectedMindMap = this.props.shapeModel.uuid;
            mindMapUtils.selectedNode = id;

            this.props.dispatch(changeContextMode(modeType.MIND_MAP_MENU));
        }.bind(this), 5);
    },
    onKeyDownHandler(e) {
        if (e.keyCode === 13) { // ENTER
            let id = this.getCorrectId(e.target.parentElement.id);

            if (id && id.indexOf('controlPoint') != -1)
                this.openMindMapMenu(id);
        }
    },
    onRotate(e) {
        e.preventDefault();
        const {shapeModel} = this.props;

        if (shapeModel.isLocked == true)
            return;

        let position = getTouchPosition(e);
        let newRotation = detectCurrentAngle(shapeModel, position.x, position.y, this.props.scaleProperties);

        if (this.state.interaction != 'rotate')
            this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, true));

        this.setState({
            rotation: newRotation,
            interaction: 'rotate'
        });
    },
    onRotationStopped(e) {
        e.preventDefault();
        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true)
            return;

        let position = getTouchPosition(e);
        let newRotation = detectCurrentAngle(shapeModel, position.x, position.y, this.props.scaleProperties);

        dispatch(updateShapeRotation(
            shapeModel.uuid,
            newRotation
        ));

        this.setState({
            rotation: newRotation,
            interaction: 'none',
            scaleOffsetX: 1,
            scaleOffsetY: 1,
            translateOffsetX: 0,
            translateOffsetY: 0,
            trX:0,
            trY:0
        });

        dispatch(refreshShapePosition(this.props.shapeModel.uuid));

        audioEditorUtils.addActionToHistory();
        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, false));

        this.updateThumbnail();
        saveManager.isContentChanged(true);
    },
    checkActiveElement() {
        if (platformDetection.isTouchableDevice() == true) {
            const { shapeModel } = this.props;

            if (isTextBox(shapeModel) == false)
                document.activeElement.blur();
        }
    },
    updateZoomProperties(properties) {
        this.setState({
            scaleOffsetX: properties.scaleX,
            scaleOffsetY: properties.scaleY,
            translateOffsetX: properties.translationX,
            translateOffsetY: properties.translationY,
            trX: properties.translationX,
            trY: properties.translationY
        });
    },
    isTextEditorMode(checkEditor = false) { // the new rich text views shouldn't be move-able while int TEXT EDITOR mode
        if (textEditorUtils.isTextEditorTool()) {
            var isDifferentShape = textEditorUtils.selectedTextShape != '' && textEditorUtils.selectedTextShape != this.props.shapeModel.uuid;

            if (isDifferentShape) {
                if (checkEditor)
                    textEditorUtils.closeTextEditor();

                return false;
            } else
                return true;
        } else
            return false;
    },
    onMoveShapeStart(e) {
        if (this.isTextEditorMode(true))
            return;

        textEditorUtils.isClick = false;
        textEditorUtils.isShapeAlreadySelected = this.props.shapeModel.isSelected;

        if (appParameters.context == modeType.PRINT)
            return;

        const {shapeModel, dispatch} = this.props;

        if (platformDetection.isIOS() == true && isTextBox(shapeModel))
            touchUtils.mouseDown();

        this.checkActiveElement();
        multiTouchUtils.endZoom();

        if (shapeModel.isLocked == true  || shapeModel.isGrouped == true) {
            e.preventDefault();
            return;
        }

        this.setState({
            interaction: 'move'
        });

        dispatch(changeInteractionState(this.props.shapeModel.uuid, true, true));

        selectionManager.checkSelection(shapeModel.uuid);
        selectionManager.updateInitialPositions(shapeModel.uuid);

        mindMapUtils.updateInitialPositions();
    },
    onMoveShape(e, coreEvent) {
        if (this.isTextEditorMode())
            return;

        if (this.state.interaction != 'move')
            return;

        const {shapeModel} = this.props;

        if (shapeModel.isLocked == true || shapeModel.isGrouped == true) {
            e.preventDefault();
            return;
        }

        if (platformDetection.isIOS()) {
            if (multiTouchUtils.isMultiTouch(e)) {
                multiTouchUtils.zoom(e, shapeModel, this.refreshShapeAfterResize, this.updateZoomProperties);

                return;
            } else
                multiTouchUtils.endZoom();

            if (multiTouchUtils.isResizing)
                return;
        }

        let newDelta = transformPointToRotatedSystem({x: coreEvent.lastX / this.scaleFactor(), y: coreEvent.lastY / this.scaleFactor()}, shapeModel.rotation);

        this.setState({
            translateOffsetX: newDelta.x,
            translateOffsetY: newDelta.y
        });

        const offsetX = coreEvent.lastX / this.scaleFactor();
        const offsetY = coreEvent.lastY / this.scaleFactor();

        selectionManager.moveShapes(offsetX, offsetY, shapeModel.uuid);
        mindMapUtils.updateShapePosition(shapeModel, offsetX, offsetY);
    },
    onMoveShapeStopped(e, coreEvent) {
        if (this.isTextEditorMode())
            return;

        textEditorUtils.isClick = false;

        const {shapeModel, dispatch} = this.props;

        if (platformDetection.isIOS() == true && isTextBox(shapeModel))
            touchUtils.mouseUp();

        if (shapeModel.isLocked == true  || shapeModel.isGrouped == true) {
            dispatch(selectShape(shapeModel.uuid));

            if (e)
                e.preventDefault();

            return;
        }

        saveManager.isContentChanged(true);

        var isMultiTouch = platformDetection.isIOS() && multiTouchUtils.isResizing;

        if (this.state.interaction != 'move')
            return;

        if (e && !isMultiTouch) {
            const newX = shapeModel.x + coreEvent.lastX / this.scaleFactor();
            const newY = shapeModel.y + coreEvent.lastY / this.scaleFactor();

            const offsetX = coreEvent.lastX / this.scaleFactor();
            const offsetY = coreEvent.lastY / this.scaleFactor();

            dispatch(updateShapePosition(
                shapeModel.uuid,
                newX,
                newY
            ));

            mindMapUtils.updateShapePosition(shapeModel,offsetX, offsetY);

            dispatch(refreshShapePosition(this.props.shapeModel.uuid));

            if (Math.abs(coreEvent.lastX) <= 2 && Math.abs(coreEvent.lastY) <= 2)
                textEditorUtils.isClick = true;

            selectionManager.moveShapes(offsetX, offsetY, shapeModel.uuid);
        }

        //document.getElementById('mainFocus').focus();

        dispatch(changeInteractionState(this.props.shapeModel.uuid, false, false));
        dispatch(selectShape(shapeModel.uuid));

        if (isMultiTouch) {
            multiTouchUtils.zoom(e, shapeModel, this.refreshShapeAfterResize);
            audioEditorUtils.addActionToHistory();
            this.updateThumbnail();

            multiTouchUtils.endZoom();

            this.setState({
                scaleOffsetX: 1,
                scaleOffsetY: 1,
                translateOffsetX: 0,
                translateOffsetY: 0,
                trX:0,
                trY:0,
                interaction:'none',
                isMultiTouch: false
            });

            return;
        }

        this.setState({
            scaleOffsetX: 1,
            scaleOffsetY: 1,
            translateOffsetX: 0,
            translateOffsetY: 0,
            trX:0,
            trY:0,
            interaction:'none',
            isMultiTouch: false
        });

        if (!e) {
            audioEditorUtils.addActionToHistory();
            this.updateThumbnail();
        } else {
            if (Math.abs(coreEvent.lastX / this.scaleFactor()) > 10 || Math.abs(coreEvent.lastY / this.scaleFactor() > 10)) {
                audioEditorUtils.addActionToHistory();
                this.updateThumbnail();
            }
        }
    },
    scaleFactor() {
        const canvasScale = this.props.scaleProperties.scale;
        return canvasScale;
    },
    render() {
        const {x, y, width, height, horizontalFlip, verticalFlip, cx, cy, isLocked} = this.props.shapeModel;
        var isSelected = this.props.shapeModel.isSelected;
        var cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5;
        let isMindMap = this.props.shapeModel.isMindMap;

        if (this.props.shapeModel.cx1 && this.props.shapeModel.cy1) {
            cx1 = this.props.shapeModel.cx1;
            cy1 = this.props.shapeModel.cy1;
        }

        if (this.props.shapeModel.cx2 && this.props.shapeModel.cy2) {
            cx2 = this.props.shapeModel.cx2;
            cy2 = this.props.shapeModel.cy2;
        }

        if (this.props.shapeModel.cx3 && this.props.shapeModel.cy3) {
            cx3 = this.props.shapeModel.cx3;
            cy3 = this.props.shapeModel.cy3;
        }

        if (this.props.shapeModel.cx4 && this.props.shapeModel.cy4) {
            cx4 = this.props.shapeModel.cx4;
            cy4 = this.props.shapeModel.cy4;
        }

        if (this.props.shapeModel.cx5 && this.props.shapeModel.cy5) {
            cx5 = this.props.shapeModel.cx5;
            cy5 = this.props.shapeModel.cy5;
        }

        if (appParameters.getMode() == modeType.PLAYER)
            isSelected = false;

        var isAnimation = animationManager.isAnimationMode();
        var showElement = true;

        if (this.props.shapeModel.type == shapeTypes.VIDEO)
            showElement = false;

        const scale = this.props.scaleProperties.scale;
        const rotationDist = 35;

        var rotation = this.props.shapeModel.rotation;

        if (rotation == undefined)
            rotation = 0;

        if (this.state.interaction == 'rotate')
            rotation = this.state.rotation;

        var scX = this.state.scaleOffsetX;
        var scY = this.state.scaleOffsetY;

        if (animationManager.isScaleAnimation(this.props.shapeModel) && animationManager.isAnimationTime) {
            if (this.props.shapeModel.animationWidth > 0 && this.props.shapeModel.animationWidth != width)
                scX = this.props.shapeModel.animationWidth / width;

            if (this.props.shapeModel.animationHeight > 0 && this.props.shapeModel.animationHeight != height)
                scY = this.props.shapeModel.animationHeight / height;
        }

        let objectTransform = `translate(${this.state.translateOffsetX} ${this.state.translateOffsetY}) scale(${scX} ${scY})`;
        let rotateTransform = `rotate(${rotation} ${width/2} ${height/2})`;
        let pathPoints;
        let translateTransform = `translate(${this.state.trX} ${this.state.trY})`;
        let flipTransform = '';

        if (horizontalFlip && verticalFlip) {
            let flipTranslateX = horizontalFlip < 0 ? -width : 0;
            let flipTranslateY = verticalFlip < 0 ? -height : 0;
            flipTransform = `scale(${horizontalFlip} ${verticalFlip}) translate(${flipTranslateX} ${flipTranslateY})`;
        }

        let isStage = (window.location.href.indexOf('stage') !== -1 || window.location.href.indexOf('localhost') !== -1);
        let simplePath = `M0 0 L${width} 0 L${width} ${height} L0 ${height} Z`;
        let rotationPath = `M${width / 2} 0 L${width / 2} -${rotationDist / scale} M0 0 L${width} 0 L${width} ${height} L0 ${height} Z`;
        let showRotation;

        if (this.props.rotatable && showElement) {
            if (!isAnimation) {
                pathPoints = rotationPath;
                showRotation = true;
            } else {
                if (isStage) {
                    pathPoints = rotationPath;
                    showRotation = true;
                } else {
                    pathPoints = simplePath;
                    showRotation = false;
                }
            }
        } else {
            pathPoints = simplePath;
            showRotation = false;
        }

        let rotateFill;
        let rotateStroke;

        if (this.state.interaction == 'rotate') {
            rotateFill = uiProperties.ROTATE_FILL_ACTIVE;
            rotateStroke = uiProperties.ROTATE_STROKE_ACTIVE;
        } else {
            rotateFill = uiProperties.ROTATE_FILL_INACTIVE;
            rotateStroke = uiProperties.ROTATE_STROKE_INACTIVE;
        }

        let cornerFill;
        let cornerStroke;

        if (this.state.interaction == 'topLeft' || this.state.interaction == 'topRight' || this.state.interaction == 'bottomRight' || this.state.interaction == 'bottomLeft' || this.state.interaction == 'middleLeft' || this.state.interaction == 'middleTop' || this.state.interaction == 'middleRight' || this.state.interaction == 'middleBottom' || this.state.interaction == 'controlPoint' || this.state.interaction == 'controlPoint1' || this.state.interaction == 'controlPoint2' || this.state.interaction == 'controlPoint3' || this.state.interaction == 'controlPoint4' || this.state.interaction == 'controlPoint5') {
            cornerFill = uiProperties.CORNER_FILL_ACTIVE;
            cornerStroke = uiProperties.CORNER_STROKE_ACTIVE;
        } else {
            cornerFill = uiProperties.CORNER_FILL_INACTIVE;
            cornerStroke = uiProperties.CORNER_STROKE_INACTIVE;
        }

        let controlFill;
        let controlStroke;

        if (this.state.interaction == 'controlPoint' || this.state.interaction == 'controlPoint1' || this.state.interaction == 'controlPoint2' || this.state.interaction == 'controlPoint3' || this.state.interaction == 'controlPoint4' || this.state.interaction == 'controlPoint5') {
            if (isMindMap) {
                controlFill = uiProperties.ROTATE_FILL_ACTIVE;
                controlStroke = uiProperties.ROTATE_STROKE_ACTIVE;
            } else {
                controlFill = uiProperties.CONTROL_FILL_ACTIVE;
                controlStroke = uiProperties.CONTROL_STROKE_ACTIVE;
            }
        } else {
            if (isMindMap) {
                controlFill = uiProperties.ROTATE_FILL_INACTIVE;
                controlStroke = uiProperties.ROTATE_STROKE_INACTIVE;
            } else {
                controlFill = uiProperties.CONTROL_FILL_INACTIVE;
                controlStroke = uiProperties.CONTROL_STROKE_INACTIVE;
            }
        }

        var radiusOffset = 0;

        if (platformDetection.isIOS())
            radiusOffset = 2;

        const radius = (uiProperties.RADIUS + radiusOffset) / scale;
        const rotationIconOffset = 4 / scale;
        const lockScale = 2;

        var isLockedVisible = false;

        if (isSelected && isLocked && previewCommands.isEditorMode() == true)
            isLockedVisible = true;

        var interactivity;

        // in animation mode, only the shapes from the current animations should be clickable
        if (animationManager.clone && !this.props.shapeModel.isGrouped) {
            let clones = animationManager.getAllAnimationTargets();
            let isInTargets = false;

            for (let idx = 0; idx < clones.length; idx ++) {
                if (clones[idx].uuid === this.props.shapeModel.uuid)
                    isInTargets = true;
            }

            if (!isInTargets)
                interactivity = 'none';
        }

        var extraRadius = radius;

        return (
            <g id={'shapeBound_' + Math.random()} pointerEvents={interactivity} transform={`translate(${x} ${y})`}>
                <g transform={rotateTransform}>
                    <g transform={objectTransform}>
                        <g transform={flipTransform}>
                            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMoveShapeStart} onDrag={this.onMoveShape} onStop={this.onMoveShapeStopped}>
                                {React.cloneElement(React.Children.only(this.props.children), {
                                    x: 0,
                                    y: 0,
                                    ref: 'shapeView'
                                })}
                            </Draggable>
                        </g>
                    </g>
                </g>
                <g transform={rotateTransform}>
                    {
                        isSelected && this.state.interaction == 'none'?
                            <path stroke={uiProperties.PATH_COLOR} strokeWidth={uiProperties.STROKE} fill="none" d={pathPoints}/>
                            : null
                    }
                    {
                        showRotation && isSelected && this.props.rotatable && showElement && (this.state.interaction == 'rotate' || this.state.interaction == 'none')?
                            <g transform={`translate(${width/2 - radius} ${-(rotationDist / scale) - radius})`}>
                                <Draggable axis="none" position={{x:0, y:0}} onDrag={this.onRotate} onStop={this.onRotationStopped}>
                                    <g>
                                        <circle cx={radius} cy={radius - extraRadius} r={radius} fill={rotateFill} strokeWidth={uiProperties.STROKE} stroke={rotateStroke}/>
                                        <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/rotate.png'} x={rotationIconOffset} y={rotationIconOffset - extraRadius} width={radius * 2 - 2 * rotationIconOffset} height={radius * 2 - 2 * rotationIconOffset} preserveAspectRatio="none"/>
                                    </g>
                                </Draggable>
                            </g>
                            : null
                    }
                    {
                        isSelected ?
                        <g transform={''}>
                        {
                            this.state.interaction == 'none' || this.state.interaction == 'topLeft' ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <circle id={'topLeft_' + Math.random()} cx={0 - extraRadius/1.5} cy={0 - extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            this.state.interaction == 'none' || this.state.interaction == 'topRight' ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <circle id={'topRight_' + Math.random()} cx={width + extraRadius/1.5} cy={0 - extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            this.state.interaction == 'none' || this.state.interaction == 'bottomRight' ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <circle id={'bottomRight_' + Math.random()} cx={width + extraRadius/1.5} cy={height + extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            this.state.interaction == 'none' || this.state.interaction == 'bottomLeft' ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <circle id={'bottomLeft_' + Math.random()} cx={0 - extraRadius/1.5} cy={height + extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && showElement &&  (this.state.interaction == 'none' || this.state.interaction == 'middleLeft') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <rect id={'middleLeft_' + Math.random()} x={- radius - extraRadius} y={height / 2 - radius} width={2 * radius} height={2 * radius} rx={3} ry={3} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && showElement &&  (this.state.interaction == 'none' || this.state.interaction == 'middleRight') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <rect id={'middleRight_' + Math.random()} x={width - radius + extraRadius} y={height / 2 - radius} width={2 * radius} height={2 * radius} rx={3} ry={3} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && showElement &&  (this.state.interaction == 'none' || this.state.interaction == 'middleTop') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <rect id={'middleTop_' + Math.random()} x={width / 2 - radius} y={- radius - extraRadius} width={2 * radius} height={2 * radius} fill={cornerFill} rx={3} ry={3} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && showElement &&  (this.state.interaction == 'none' || this.state.interaction == 'middleBottom') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleShapeStopped}>
                                    <rect id={'middleBottom_' + Math.random()} x={width / 2 - radius} y={height - radius + extraRadius} width={2 * radius} height={2 * radius} rx={3} ry={3} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && this.props.isBubble && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onControlPointStart} onDrag={this.onControlPointDrag} onStop={this.onControlPointStop}>
                                    {
                                        isMindMap ?
                                        <g id={'controlPoint_' + Math.random()}>
                                            <a href='#' onKeyDown={this.onKeyDownHandler}>
                                                <circle cx={cx - x} cy={cy - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                            </a>
                                            <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg'} x={cx - x - radius} y={cy - y - radius} width={radius * 2} height={radius * 2} preserveAspectRatio="none"/>
                                        </g>
                                        :
                                        <circle id={'controlPoint_' + Math.random()} cx={cx - x} cy={cy - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                    }
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && this.props.isBubble && cx1 && cy1 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint1') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onControlPointStart} onDrag={this.onControlPointDrag} onStop={this.onControlPointStop}>
                                    {
                                        isMindMap ?
                                            <g id={'controlPoint1_' + Math.random()}>
                                                <a href='#' onKeyDown={this.onKeyDownHandler}>
                                                    <circle cx={cx1 - x} cy={cy1 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                                </a>
                                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg'} x={cx1 - x - radius} y={cy1 - y - radius} width={radius * 2} height={radius * 2} preserveAspectRatio="none"/>
                                            </g>
                                            :
                                            <circle id={'controlPoint1_' + Math.random()} cx={cx1 - x} cy={cy1 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                    }
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && this.props.isBubble && cx2 && cy2 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint2') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onControlPointStart} onDrag={this.onControlPointDrag} onStop={this.onControlPointStop}>
                                    {
                                        isMindMap ?
                                            <g id={'controlPoint2_' + Math.random()}>
                                                <a href='#' onKeyDown={this.onKeyDownHandler}>
                                                    <circle cx={cx2 - x} cy={cy2 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                                </a>
                                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg'} x={cx2 - x - radius} y={cy2 - y - radius} width={radius * 2} height={radius * 2} preserveAspectRatio="none"/>
                                            </g>
                                            :
                                            <circle id={'controlPoint2_' + Math.random()} cx={cx2 - x} cy={cy2 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                    }
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && this.props.isBubble && cx3 && cy3 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint3') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onControlPointStart} onDrag={this.onControlPointDrag} onStop={this.onControlPointStop}>
                                    {
                                        isMindMap ?
                                            <g id={'controlPoint3_' + Math.random()}>
                                                <a href='#' onKeyDown={this.onKeyDownHandler}>
                                                    <circle cx={cx3 - x} cy={cy3 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                                </a>
                                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg'} x={cx3 - x - radius} y={cy3 - y - radius} width={radius * 2} height={radius * 2} preserveAspectRatio="none"/>
                                            </g>
                                            :
                                            <circle id={'controlPoint3_' + Math.random()} cx={cx3 - x} cy={cy3 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                    }
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && this.props.isBubble && cx4 && cy4 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint4') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onControlPointStart} onDrag={this.onControlPointDrag} onStop={this.onControlPointStop}>
                                    {
                                        isMindMap ?
                                            <g id={'controlPoint4_' + Math.random()}>
                                                <a href='#' onKeyDown={this.onKeyDownHandler}>
                                                    <circle cx={cx4 - x} cy={cy4 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                                </a>
                                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg'} x={cx4 - x - radius} y={cy4 - y - radius} width={radius * 2} height={radius * 2} preserveAspectRatio="none"/>
                                            </g>
                                            :
                                            <circle id={'controlPoint4_' + Math.random()} cx={cx4 - x} cy={cy4 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                    }
                                </Draggable>
                            </g>
                            : null
                        }
                        {
                            !isAnimation && this.props.isBubble && cx5 && cy5 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint5') ?
                            <g transform={translateTransform}>
                                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onControlPointStart} onDrag={this.onControlPointDrag} onStop={this.onControlPointStop}>
                                    {
                                        isMindMap ?
                                            <g id={'controlPoint5_' + Math.random()}>
                                                <a href='#' onKeyDown={this.onKeyDownHandler}>
                                                    <circle cx={cx5 - x} cy={cy5 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                                </a>
                                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg'} x={cx5 - x - radius} y={cy5 - y - radius} width={radius * 2} height={radius * 2} preserveAspectRatio="none"/>
                                            </g>
                                            :
                                            <circle id={'controlPoint5_' + Math.random()} cx={cx5 - x} cy={cy5 - y} r={radius} fill={controlFill} strokeWidth={uiProperties.STROKE} stroke={controlStroke}/>
                                    }
                                </Draggable>
                            </g>
                            : null
                        }
                        </g>
                        : null
                    }
                    {
                        isLockedVisible ?
                            <g transform={`translate(${width/2 - 10/lockScale} ${height/2 - 12.5/lockScale}) scale(${1/lockScale} ${1/lockScale})`}>
                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/lock.png'} x="0" y="0" width="20px" height="25px" preserveAspectRatio="none"/>
                            </g>
                            : null
                    }
                </g>
            </g>
    );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/interactive/InteractiveShape.js
 **/